<template>
  <nna-container no-padding>
    <md-card-media md-ratio="16:9" class="shop__image">
      <img :src="`${image}normal`">
    </md-card-media>
    <div class="shop__content">
      <md-card-header class="text-align-center">
        <div class="md-subhead">{{category}}</div>
        <div class="md-title pt-2">{{name}}</div>
        <p><nna-read-more :text="description" /></p>
      </md-card-header>
      <div class="gmap p-1">
        <!--<GmapMap
          :center="position"
          :zoom="10"
          map-type-id="terrain"
          style="width: auto; height: 300px"
          :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUI: false,
              styles: this.gmapStyle
            }"
          >
          <GmapMarker
            :position="position"
            :clickable="false"
            :draggable="false"
            />                  
        </GmapMap>-->
        <iframe 
          width="500" 
          height="170" 
          frameborder="0" 
          scrolling="no" 
          marginheight="0" 
          marginwidth="0" 
          :src="`https://maps.google.com/maps?q=${position.lat},${position.lng}&z=14&amp;output=embed`"
        >
        </iframe>
      </div>
      <md-list>
        <md-list-item v-if="address">
          <md-icon>place</md-icon>
          <span class="md-list-item-text">{{address}}</span>
        </md-list-item>
        <md-list-item v-if="openingTime">
          <md-icon>access_time</md-icon>
          <span class="md-list-item-text" v-if="isOpen">{{openingTime}}</span>
          <span class="md-list-item-text" v-else>chiuso</span>
        </md-list-item>      
      </md-list>
      <div class="pl-3 pr-3">
        <nna-row>
          <nna-col align="left">
            <span><a @click="goToServicesPage">Servizi offerti</a></span><span><md-icon>navigate_next</md-icon></span>
          </nna-col>
        </nna-row>        
        <nna-row>
          <nna-col align="left">
            <span><a @click="goToTermsOfCancellationPage">Termini di cancellazione</a></span><span><md-icon>navigate_next</md-icon></span>
          </nna-col>
        </nna-row>        
        <nna-row>        
          <nna-col align="left">
            <span><a @click="goToRuleBookPage">Regolamento</a></span><span><md-icon>navigate_next</md-icon></span>
          </nna-col>                
        </nna-row>
      </div>
    </div>
    <nna-action-footer padding>
      <nna-button class="pb-3" @click.native="goToServices" v-if="isReservation">PRENOTA</nna-button>
      <nna-button v-if="registeredUser" @click.native="goToProducts">VAI ALLO SHOP</nna-button>     
      <!--<a :href="`https://www.google.com/maps/?q=${lat},${lng}`" target="_blank" v-else>
         <nna-button>AVVIA LA NAVIGAZIONE</nna-button>
      </a>-->      
    </nna-action-footer>
  </nna-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import gmapStyleJson from '@/modules/shop/gmap.style.json'
export default {
  name: 'Shop',
  components: {
  },
  data() {
    return {
      shop_id: this.$route.params.id,
      gmapStyle: gmapStyleJson
    }
  },
  computed: {
    ...mapGetters({
      shop: 'shops/current',
      reservationDate: 'global/reservationDate',
    }),
    name() {
      return this.shop ? this.shop.name : ''
    },
    image() {
      return this.shop ? this.shop.image : ''
    },    
    category() {
      return this.shop ? this.shop.category : ''
    },
    description() {
      return this.shop ? this.shop.description : ''
    },
    isOpen() {
      return this.shop ? this.shop.isOpen : ''
    },
    registeredUser() {
      return this.shop ? this.shop.registeredUser : ''
    },
    position() {
      return this.shop && this.shop.position ? this.shop.position : {}
    },    
    lat() {
      return this.shop && this.shop.position ? this.shop.position.lat : ''
    },
    lng() {
      return this.shop && this.shop.position ? this.shop.position.lng : ''
    },
    isReservation() {
      return this.reservationDate
    },
    servicesPage() {
      return this.shop ? this.shop.services : []
    },
    termsOfCancellationPage() {
      return this.shop ? this.shop.termsOfCancellation : ''
    },
    ruleBookPage() {
      return this.shop ? this.shop.ruleBook : ''
    },
    servicesOfferedIcon() {
      return this.shop ? this.shop.offered_services : []
    },  
    address() {
      return this.shop ? this.shop.address : ''
    },        
    openingTime() {
      return this.shop ? this.shop.openingTime : ''
    },            
  },
  methods: {
    ...mapActions({
      shopDetail: 'shops/shopDetail'
    }),
    goToProducts() {
      this.$store.commit("cart/CART_CLEAN")
      this.$router.push({ name: 'shop.products' })     
    },
    goToServices() {
      this.$store.commit("cart/CART_CLEAN")
      this.$router.push({ name: 'shop.services' })      
    },    
    async onShopDetail() {
      try { 
        const { data } = await this.shopDetail(this.shop_id)
        if(data.hcode === "ok") {
        } else {
          this.$router.back()
          this.$toasted.show(data.msg, { type: 'error' })
        }        
     } catch (errors) {
       console.error("Error:", errors)
       this.sending = false       
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
       this.$router.back()
      }      
    },
    goToServicesPage() {
      this.$router.push({ name: 'servicesoffered',  params: { page: { list: this.servicesOfferedIcon, title: "Servizi offerti" } }})
    },
    goToTermsOfCancellationPage(copy) {
      this.$router.push({ name: 'terms', params: { page: { copy: this.termsOfCancellationPage, title: "Termini di cancellazione" } }})
    },
    goToRuleBookPage(copy) {
      this.$router.push({ name: 'terms', params: { page: { copy: this.ruleBookPage, title: "Regolamento" } }})
    }    
  },
  mounted() {
    this.onShopDetail()
  },
  beforeDestroy() {
    //this.$store.commit('shops/SHOP_CURRENT_CLEAN')
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/Shop/pages/Shop.vue